import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type DataTableBadgeTone =
  | 'neutral'
  | 'primary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

export type DataTableBadgeAppearance = 'soft' | 'solid';

@Component({
  selector: 'app-data-table-badge',
  templateUrl: './data-table-badge.component.html',
  styleUrls: ['./data-table-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTableBadgeComponent {
  @Input() label = '';
  @Input() icon?: string;
  @Input() tone: DataTableBadgeTone = 'neutral';
  @Input() appearance: DataTableBadgeAppearance = 'soft';

  get badgeClasses(): string[] {
    return [
      'data-table-badge',
      `data-table-badge--${this.tone}`,
      `data-table-badge--${this.appearance}`
    ];
  }
}
